import {
    DateInfo,
    IconWrapper,
    MatchContainer,
    MatchDetails,
    MatchInfo,
    MatchItem,
    MiscInfo,
    PlayerGoals,
    PlayerInfo,
    PlayerTitle,
    PlayerTitleDiv,
    ResultInfo,
    Score,
    ScoreContainer,
    StageInfo,
    TeamDiv,
    TeamInfo,
    TeamInfoText,
    TeamTitle,
} from "./Match.styles";
import React, { useState } from "react";
import Logo from "../../../components/logos/Logo/Logo";
import { ColoredText } from "../../../parts/Navbar/Navbar.styles";
import { MAIN_COLOR } from "../../../components/globalThemes";
import { formatDate } from "../../../helpers/helpersFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFutbol, faStar } from "@fortawesome/free-solid-svg-icons";
import { SHORT_NAME, SHORT_NAME_TEAM } from "../../../utils/info";

const Match = ({
    enemyName,
    clubGoals,
    enemyGoals,
    result,
    date,
    size = "small",
    goalsInfo,
    round,
    comment,
}) => {
    const [displayDetails, setDisplayDetails] = useState(false);

    const renderGoalsInfo = () => {
        return goalsInfo.map((e, index) => (
            <PlayerInfo key={e.player_id + index}>
                <IconWrapper>
                    <FontAwesomeIcon
                        icon={faStar}
                        color={"gold"}
                        style={{
                            width: 8,
                            height: 8,
                            opacity: index === 0 && e.goals ? 1 : 0,
                            marginRight: 5,
                            marginTop: 1,
                        }}
                    />
                </IconWrapper>
                <PlayerTitle>
                    {e.player_name + " " + e.player_surname}
                </PlayerTitle>
                <IconWrapper>
                    <PlayerGoals goals={e.goals}>{e.goals}</PlayerGoals>
                    <FontAwesomeIcon
                        icon={faFutbol}
                        color={"#c2c2c2"}
                        style={{
                            width: 8,
                            height: 8,
                            opacity: e.goals ? 1 : 0,
                            marginLeft: 3,
                            marginTop: 2,
                        }}
                    />
                </IconWrapper>
            </PlayerInfo>
        ));
    };

    if (size === "small") {
        return (
            <MatchItem size={size}>
                <DateInfo>{formatDate(date, "short")}</DateInfo>
                <TeamTitle>
                    <Logo width={25} height={25} style={{ marginRight: 3 }} />
                    <ColoredText
                        color={MAIN_COLOR}
                    >{`${SHORT_NAME} `}</ColoredText>
                    {SHORT_NAME_TEAM}
                </TeamTitle>
                <ScoreContainer>
                    <Score result={result}>{clubGoals}</Score>
                    <Score>{" : "}</Score>
                    <Score>{enemyGoals}</Score>
                </ScoreContainer>
                <TeamTitle>{enemyName}</TeamTitle>
                <ResultInfo result={result} />
            </MatchItem>
        );
    }

    return (
        <MatchContainer>
            <MatchItem
                size={size}
                onClick={() => setDisplayDetails(!displayDetails)}
            >
                <DateInfo>{formatDate(date, "medium")}</DateInfo>
                <MatchInfo>
                    <TeamTitle>
                        <Logo
                            width={25}
                            height={25}
                            style={{ marginRight: 3 }}
                        />
                        <ColoredText color={MAIN_COLOR}>
                            {`${SHORT_NAME} `}
                        </ColoredText>
                        {SHORT_NAME_TEAM}
                    </TeamTitle>
                    <ScoreContainer>
                        <Score result={result}>{clubGoals}</Score>
                        <Score>{" : "}</Score>
                        <Score color={"white"}>{enemyGoals}</Score>
                    </ScoreContainer>
                    <TeamTitle>{enemyName}</TeamTitle>
                </MatchInfo>
                <MiscInfo>
                    <StageInfo round={round} />
                    <ResultInfo result={result} />
                </MiscInfo>
            </MatchItem>
            <MatchDetails showItem={displayDetails}>
                <TeamDiv>
                    {comment && (
                        <TeamInfo>
                            {"Informacja: "}
                            <TeamInfoText>{comment}</TeamInfoText>
                        </TeamInfo>
                    )}
                    <TeamInfo>{"Skład zespołu:"}</TeamInfo>
                    <PlayerTitleDiv>{renderGoalsInfo()}</PlayerTitleDiv>
                </TeamDiv>
            </MatchDetails>
        </MatchContainer>
    );
};

export default Match;
